__turbopack_context__.v({
  "intro": "SitemapPage-module__7rdwtq__intro",
  "page": "SitemapPage-module__7rdwtq__page",
  "tree": "SitemapPage-module__7rdwtq__tree",
});
